import type { ProjectName } from '@utilities/env';
import { HOSTS, PROJECT_NAME, PROJECT_NAMES } from '@utilities/env';

export const GENERAL_URLS = {
  staking: process.env.NEXT_PUBLIC_STAKING_HOST || 'https://magicsquare.io/staking',
  otc: 'https://spring.net/discover/magic-square',
  dao: 'https://dao.magicsquare.io',
  privacyPolicy: 'https://docs.magicsquare.io/documents/legal-documents/privacy-policy',
  termsAndConditions:
    'https://docs.magicsquare.io/documents/legal-documents/magic-store-terms-and-conditions',
  sqrTokenIntroduction: 'https://docs.magicsquare.io/sqr-token/sqr-token-introduction',
};

export const getNextProjectsUrlGenerators = (currentProjectName?: ProjectName) => {
  const getUrlGetter = (projectName: ProjectName) => {
    return (path: string, absolute = false) => {
      if (currentProjectName === projectName && !absolute) {
        return path;
      }

      return `${HOSTS[projectName]}${path}`;
    };
  };

  return {
    store: getUrlGetter(PROJECT_NAMES.STORE),
    staking: getUrlGetter(PROJECT_NAMES.STAKING),
    launchpad: getUrlGetter(PROJECT_NAMES.LAUNCHPAD),
    swap: getUrlGetter(PROJECT_NAMES.SWAP),
    magicsquare: getUrlGetter(PROJECT_NAMES.MAGIC_SQUARE),
  };
};

export const nextProjectUrl = getNextProjectsUrlGenerators(PROJECT_NAME);
